import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Navbar extends Component {

    render() {
        let publicUrl = process.env.PUBLIC_URL+'/'
        let imgattr = 'logo'
        let anchor = ''
        return (
        	<div className="navbar-area navbar-area-1">
			  {/* navbar top start */}
			  <div className="navbar-top">
			    <div className="container">
			      <div className="row">
			        <div className="col-lg-8 col-6 text-lg-left text-center">
			          <ul>
			            <li><p><a href="tel:0401812910"><i class="fa-solid fa-square-phone-hangup"></i> <span class="hide-m">0401812910</span></a></p></li>
			            <li><p><a href="tel:0401812910"><i class="fa-sharp fa-solid fa-envelope"></i>  <span class="hide-m">info@masalahut.fi</span></a></p></li>
			          </ul>
			        </div>
			        <div className="col-lg-4 col-6">
			          <ul className="topbar-right text-lg-right text-center">
			            <li>
			              <Link to="/SignIn"><i class="fa-regular fa-user"></i> <span class="hide-m">Login</span></Link>
			            </li>
			            <li className="social-area">
			              <a href="https://www.facebook.com/"><i className="fab fa-facebook-f" aria-hidden="true" /></a>
			              <a href="https://www.instagram-plus.com/"><i className="fab fa-instagram" aria-hidden="true" /></a>
			            </li>
			          </ul>
			        </div>
			      </div>
			    </div>
			  </div>
			  <nav className="navbar navbar-expand-lg">
			    <div className="container nav-container">
			      <div className="responsive-mobile-menu">
			        <button className="menu toggle-btn d-block d-lg-none" data-target="#dkt_main_menu" aria-expanded="false" aria-label="Toggle navigation">
			          <span className="icon-left" />
			          <span className="icon-right" />
			        </button>
			      </div>
			      <div className="logo">
			        <Link to="/"><img src={publicUrl+"assets/img/logo.png"} alt="img" /></Link>
			      </div>
			      <div className="nav-right-part nav-right-part-mobile">
			        <ul>
			          <li><Link className="btn btn-base" to="/CartPagem"><span className="btn-icon"><i class="fa-solid fa-cart-plus"></i></span> <span className="btn-text">View Cart</span></Link></li>
			        </ul>
			      </div>
			      <div className="collapse navbar-collapse" id="dkt_main_menu">
			        <ul className="navbar-nav menu-open text-center">
			          <li>
			            <Link to="/">Home</Link>
			          </li>
			          <li>
			            <Link to="About">About Us</Link>
			          </li>
			          <li className="menu-item-has-children current-menu-item">
			            <a href="#">Menu</a>
			            <ul className="sub-menu">
			              <li><Link to="/MainMenu">A-LA-CARTE</Link></li>
			              <li><Link to="/">LOUNAS LISTA</Link></li>
			            </ul>
			          </li>
			          <li>
			            <a href="#">Reservation</a>
			          </li>
			          <li><Link to="/">Gallery</Link></li>
			          <li><Link to="Contact">Contact</Link></li>
			        </ul>
			      </div>
			      <div className="nav-right-part nav-right-part-desktop">
			        <ul>
			          <li><Link className="btn btn-base" to="/CartPagem"><span className="btn-icon"><i class="fa-solid fa-cart-plus"></i></span> <span className="btn-text">VIEW CART</span></Link></li>
			        </ul>
			      </div>
			    </div>
			  </nav>
			</div>

        )
    }
}


export default Navbar